import { render, staticRenderFns } from "./VaultsDashboard.vue?vue&type=template&id=c4cfe400&"
import script from "./VaultsDashboard.vue?vue&type=script&lang=js&"
export * from "./VaultsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports